import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./app/App/App";

// Importing the Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";

import axios from "axios";

axios.defaults.baseURL = process.env.REACT_APP_URL;

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
